import React, { createContext, useState, ReactNode } from "react";

type WalkthroughContextType = {
  startWalkthrough: boolean;
  setStartWalkthrough: any;
  isHeaderWalkthroughDone: boolean;
  setIsHeaderWalkthroughDone: any;
};

export const WalkthroughContext = createContext<
  WalkthroughContextType | undefined
>(undefined);

interface WalkthroughProviderProps {
  children: ReactNode;
}
export const WalkthroughProvider: React.FC<WalkthroughProviderProps> = ({
  children,
}) => {
  const [startWalkthrough, setStartWalkthrough] = useState(false);
  const [isHeaderWalkthroughDone, setIsHeaderWalkthroughDone] = useState(false);

  return (
    <WalkthroughContext.Provider
      value={{
        startWalkthrough,
        setStartWalkthrough,
        isHeaderWalkthroughDone,
        setIsHeaderWalkthroughDone,
      }}
    >
      {children}
    </WalkthroughContext.Provider>
  );
};
